import React from 'react';
import HeaderTop from './../common/headerTop/headerTop';
import LeftNav from './../common/leftnav/leftnav';
import { withRouter } from "react-router-dom";
import { FirewallService as firewallService } from './../../services/firewall.service';
import { ServerService as instanceService } from './../../services/server.service';
import CommonMessage from '../common/commonMessage';
import ReactToolTip from 'react-tooltip';
import $ from 'jquery';
import { AuditLog } from './../../services/auditlog.service';
import RegionService from '../../services/region.service';
import './../server/Region.css';
import Axios from 'axios';
import { API_HOST, axiosInstance, axiosRequestWithAuth } from './../../constants/server.constant';
import { getMessage } from '../../constants/messagesMapper';
import { ResourceService } from './../../services/resource.service';
import { Redirect } from 'react-router-dom';
import ScrollArea from 'react-scrollbar';
import NotificationSlider from '../common/topRightHeader/notificationSlider';
import BmrSlider from '../common/topRightHeader/bmrSlider';

class Firewall extends React.Component {

    constructor(props) {
        super(props);
        //loadcss();
        this.state = {
            loading: true,
            firewallForm: {
                name: '',
                regionUrl: '',
                regionName: ''
            },
            firewalls: [],
            enablefirewalloptions: false,
            rowname: "",
            regionList: [],
            errorMsg: '',
            msgType: '',
            selectedFirewallId: '',
            selectedRegionUrl: '',
            message: '',
            isAction: false,
            regionName: '',
            instanceList: [],
            regionErrorMsg: '',
            nameErrorMsg: '',
            isCreateAction: false,
            regionListFilter: [],
            regions: [],
            countryName: '',
            isregionselected: false,
            nametoggle: false,
            datetoggle: true,
            sizetoggle: true,
            isUserSubscribed: false,
            isRedirectToCCPage: false,
            regionMaintList: [],
            isRegionStatus: false,
            regionCount: 0,
            regionString: "",
            isCluster: ""
        };
        this.editFirewall = this.editFirewall.bind(this);
        this.getfirewalloptions = this.getfirewalloptions.bind(this);
        this.checkForSubscription = this.checkForSubscription.bind(this);
        this.scrollRef = React.createRef();

    };

    componentDidMount() {
        // if (!sessionStorage.firewallLoaded) {
        //     asyncCall().then(() => {
        //         this.setState({ loading: false })
        //         this.startLoading();
        //     });
        // } else {
        // }

        this.checkForSubscription();

    }
    checkForSubscription = () => {
        this.setState({ isAction: true });
        ResourceService.getSubscriptionDetails().then(resp => {
            if(resp === false) {
                this.setState({
                    isAction: false,
                    message: "Error while getting user subscription details"

                });
                return;
            }
            if(resp.error) {
                this.setState({
                    isAction: false,
                    isUserSubscribed: true
                });
                this.loadRegions();
            }
            else {
                this.startLoading();
                this.getMaintananceRegions();
                var cluster = localStorage.getItem("clusterMessage");
                if(cluster !== null && cluster !== undefined) {
                    this.setState({
                        isCluster: localStorage.getItem("clusterMessage")
                    });
                }
                else {
                    localStorage.setItem("clusterMessage", "show");
                    this.setState({
                        isCluster: "show"
                    });
                }

            }

        });
    };


    getMaintananceRegions = () => {
        let userId = localStorage.getItem("userId");
        axiosInstance.get(API_HOST + "/regions/maintainance/" + userId, axiosRequestWithAuth).
            then(resp => {
                console.log(resp);
                let res = resp.data;
                let string = "";
                this.setState({
                    regionCount: res.length,
                    regionMaintList: res
                });
                if(res.length > 0) {
                    for(let i = 0; i < res.length; i++) {
                        string += res[i].name + " (" + res[i].region_id + ")" + ", ";
                    }
                    this.setState({
                        isRegionStatus: true,
                        regionString: string.replace(/,\s*$/, "")
                    });
                }

            })
            .catch(error => {
                console.log(error);
            });
    };

    startLoading() {
        this.loadRegions();
        this.getAllInstances();
        this.getRegion();
        this.loadFirewallList();
    }

    loadFirewallList() {
        this.setState({ isAction: true });
        firewallService.getFirewallList().then(data => {
            if(!Array.isArray(data) || (data && data.message)) {
                this.setState({ isAction: false });
                return;
            }
            this.setState({ firewalls: this.getSortableData('date', data), isAction: false }, () => this.activateActionMenu());
            //this.setSortable('name');
        });
    }
    activateActionMenu() {
        var documentwindowHeight = $(document).height();
        $('.dashboard_module .table_data .tr .row_menu_icon, .tabular_data_wrap li .menu_icon').click(function () {
            $('.tabular_data_wrap .table_data .tr').removeClass('active');
            $(this).closest('.tr').addClass('active');
            //$(this).closest('.dashboard_module .tr').find('.dropdown_component').toggleClass('active');
            $(this).find('.dropdown_component').css({ top: '30px' });
            var fmi = 'dropdown_component';
            var offset = $(this).offset();
            var x = (offset.left);
            var y = (offset.top);
            var windowHeight = $(window).height();
            var menuHeight = $(this).find('.' + fmi).height();
            var totalHeight = menuHeight + y;
            if(documentwindowHeight < totalHeight) {
                $('.' + fmi).css({ top: -Math.abs(menuHeight + 10) });
                $('.arrow_pointer').addClass('bottom_arrow');
            }
            else if(documentwindowHeight > totalHeight) {
                totalHeight = totalHeight - windowHeight;
                totalHeight = totalHeight + 50;
                $('.arrow_pointer').removeClass('bottom_arrow');

                window.scrollTo({ top: totalHeight, behavior: 'smooth', });
            }
        });
    }

    scrollTop() {
        if(this.scrollRef && this.scrollRef.current && this.scrollRef.current.scrollArea) {
            this.scrollRef.current.scrollArea.scrollTop();
        }
    }

    editFirewall = (params) => {
        this.props.history.push({
            pathname: "/firewall-edit",
            state: {
                id: params[2],
                regionUrl: params[3],
                regionName: params[4],
                name: params[0]
            }
        });


    };

    getfirewalloptions = (event, params) => {

        this.setState({
            enablefirewalloptions: !this.state.enablefirewalloptions,
            rowname: params
        });

        event.stopPropagation();
    };

    getRegion() {
        instanceService.getRegionListByType('network').then(data => {
            if(!Array.isArray(data) || (data && data.message)) {
                return;
            }
            data.sort(function (a, b) {
                if(a.region < b.region) { return -1; }
                if(a.region > b.region) { return 1; }
                return 0;
            });
            this.setState({ regionList: data });
        });
    }

    getAllInstances() {
        instanceService.getServerList(false).then(data => {
            if(!Array.isArray(data) || (data && data.message)) {
                this.setState({ message: data.message, isAction: false, msgType: 'error' });
                return;
            }
            this.setState({ instanceList: data });
        });
    }

    formChangeHandler = (event) => {
        let name = event.target.name;
        let val = event.target.value;

        let form = this.state.firewallForm;
        form[name] = val;
        // if(name==='region' && val) {
        //     let item = this.state.regionList.find(elem=>elem.region===val)
        //     form.regionUrl = item.url
        //     form.regionName = item.region
        // }
        // if (name = 'name' && val.length > 20) {
        //     return
        // }
        this.setState({ firewallForm: form, errorMsg: '', nameErrorMsg: '', regionErrorMsg: '' });
    };

    createFirewallSubmit = (event) => {
        event.preventDefault();

        if(!this.validate()) {
            return;
        }
        // if (this.isFirewallNameExist(this.state.firewallForm.name.trim())) {
        //     this.setState({ errorMsg: 'Name should not be duplicate' })
        //     return
        // }
        if(this.state.isUserSubscribed) {
            this.setState({
                isRedirectToCCPage: true
            });
            return;
        }
        if(this.state.isCreateAction) {
            return;
        }

        let requestBody = {
            name: this.state.firewallForm.name.trim(),
            description: this.state.firewallForm.name
        };
        this.setState({ isCreateAction: true });
        let i18n = this.props.i18n;
        firewallService.createFirewall(JSON.stringify(requestBody), this.state.firewallForm.regionUrl).then(data => {
            if(data && data.security_group && data.security_group.name) {
                let fullRegionList = JSON.parse(localStorage.getItem('fullRegionList'));
                const addFirewall = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Firewall " + requestBody.name + " has been added",
                    "operation": "Firewall Added",
                    "region": this.state.firewallForm.regionName
                };
                AuditLog.storeAuditLogs(addFirewall, "instance").then((resp) => {
                    if(resp === false);
                });
                this.props.history.push({
                    pathname: "/firewall-edit",
                    state: {
                        firewallName: data.security_group.name,
                        sgRules: data.security_group.security_group_rules,
                        id: data.security_group.id,
                        regionUrl: this.state.firewallForm.regionUrl,
                        regionName: this.state.firewallForm.regionName,
                        name: data.security_group.name
                    }
                });
                return;
            }
            if(data && data.NeutronError && data.NeutronError.message) {
                let newMessage = getMessage(data.NeutronError.message);
                this.setState({ message: newMessage, isCreateAction: false, msgType: 'error' });
                return;
            }
            this.setState({ message: i18n.t('fw_action_failure').replace('action', 'create'), isCreateAction: false, msgType: 'error' });
        });

    };

    validate() {
        if(this.state.isUserSubscribed) {
            if(this.state.firewallForm.regionName === undefined || this.state.firewallForm.regionName === '') {
                this.setState({ regionErrorMsg: 'Region should be selected' });
                return false;
            }
        }
        else {
            if(this.state.firewallForm.regionUrl === undefined || this.state.firewallForm.regionUrl === '') {
                this.setState({ regionErrorMsg: 'Region should be selected' });
                return false;
            }
        }

        if(this.state.firewallForm.name === undefined || this.state.firewallForm.name.trim() === '') {
            document.getElementById('secgName').focus();
            this.setState({ nameErrorMsg: 'Name should not be blank' });
            return false;
        }
        if(this.state.firewallForm.name.length > 20) {
            document.getElementById('secgName').focus();
            this.setState({ nameErrorMsg: 'Name should not be more than 20 characters' });
            return false;
        }
        this.setState({ nameErrorMsg: '', regionErrorMsg: '' });
        return true;
    }

    isFirewallNameExist(name) {
        let firewallList = this.state.firewalls;
        if(firewallList.length > 0) {
            let regnList = firewallList.filter(item => item.region_name === this.state.firewallForm.regionName);
            if(regnList.length > 0) {
                let ob = regnList.find(elem => elem.name === name);
                if(ob !== undefined) {
                    return true;
                }
            }
        }
        return false;
    }

    firewallDeleteById = () => {
        this.deletePoupClose();
        this.setState({ isAction: true });
        let firewallId = this.state.selectedFirewallId;
        let firewallNameDelete = this.state.selectedFirewallName;
        let i18n = this.props.i18n;
        if(this.isFirewallIdAttachedToInst(this.state.selectedFirewallName, this.state.selectedFirewallRegion)) {
            this.setState({ message: i18n.t('fw_delete_failure'), isAction: false, msgType: 'warning' });
            return;
        }

        firewallService.deleteFirewallByid(firewallId, this.state.selectedRegionUrl).then(res => {
            if(res) {
                const firewalldeleted = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Firewall " + firewallNameDelete + " has been deleted",
                    "operation": "Firewall Deleted",
                    "region": this.state.selectedFirewallRegion
                };
                AuditLog.storeAuditLogs(firewalldeleted, "instance").then((resp) => {
                    if(resp === false);
                });
                let newList = this.state.firewalls.filter(item => item.id !== firewallId);
                this.setState({ message: i18n.t('fw_delete_success'), isAction: false, firewalls: newList, msgType: 'success' });
            } else {
                this.setState({ message: i18n.t('fw_action_failure').replace('action', 'delete'), isAction: false, msgType: 'error' });
            }
        });
    };

    isFirewallIdAttachedToInst(firewallName, region) {
        let isFirewallAttachedToInst = false;
        let instanceList = this.state.instanceList.filter(item => item.region === region);
        for(let i = 0; i < instanceList.length; i++) {
            let instance = instanceList[i];
            if(instance.security_groups !== undefined) {
                let firewallObj = instance.security_groups.find(item => item.name === firewallName);
                if(firewallObj !== undefined) {
                    isFirewallAttachedToInst = true;
                    break;
                }
            }
        }
        return isFirewallAttachedToInst;
    }

    headerSortClick = (event) => {
        $('.sort_icon').removeClass('active');
        $(event.currentTarget).find('.sort_icon').addClass('active');
        $(event.currentTarget).find('.sort_icon').toggleClass('toggle_sort');
    };

    setSortable = (type) => {
        this.setState({ firewalls: this.getSortableData(type, this.state.firewalls) });
    };

    getSortableData = (type, items) => {
        if(items && items.length === 0) {
            return items;
        }
        if(type === "name") {
            if(this.state.nametoggle) {
                items.sort(function (a, b) {
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return 1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return -1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {

                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                    return 0;
                });
            }
            this.setState({ nametoggle: !this.state.nametoggle });
            return items;
        }
        else if(type === "region") {
            if(this.state.regiontoggle) {
                items.sort(function (a, b) {
                    if(a.fullRegion < b.fullRegion) { return 1; }
                    if(a.fullRegion > b.fullRegion) { return -1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(a.fullRegion < b.fullRegion) { return -1; }
                    if(a.fullRegion > b.fullRegion) { return 1; }
                    return 0;
                });
            }
            this.setState({ regiontoggle: !this.state.regiontoggle });
            return items;
        }
        else if(type === "date") {
            if(this.state.datetoggle) {
                items.sort(function (a, b) {
                    return new Date(b.created_on) - new Date(a.created_on);
                });
            }
            else {
                items.sort(function (a, b) {
                    return new Date(a.created_on) - new Date(b.created_on);
                });
            }
            this.setState({ datetoggle: !this.state.datetoggle });
            return items;
        }
        else if(type === "rules") {
            if(this.state.rulestoggle) {
                items.sort(function (a, b) {
                    if(a.rules_count < b.rules_count) { return 1; }
                    if(a.rules_count > b.rules_count) { return -1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(a.rules_count < b.rules_count) { return -1; }
                    if(a.rules_count > b.rules_count) { return 1; }
                    return 0;
                });
            }
            this.setState({ rulestoggle: !this.state.rulestoggle });
            return items;
        }
        return items;
    };

    createFirewallClick() {
        let form = this.state.firewallForm;
        form.regionUrl = '';
        form.regionName = '';
        form.name = '';
        this.setState({ firewallForm: form, errorMsg: '', regionErrorMsg: '', nameErrorMsg: '', isregionselected: false });
        $('.create_firewall_popup').addClass('active');
        $(".regionSelect_options").removeClass("active");
        //document.getElementById('createBtn').focus()
    }

    createFirewallClose() {
        $('.create_firewall_popup').removeClass('active');
    }

    deletePoupClick(firewall) {
        this.setState({ selectedFirewallId: firewall.id, selectedRegionUrl: firewall.region_url, selectedFirewallName: firewall.name, selectedFirewallRegion: firewall.region_name });
        $('.delete_firewall_popup').addClass('active');
        $("body").addClass("popup_no_scroll");
        document.getElementById('deleteBtn').focus();
    }

    deletePoupClose() {
        $('.delete_firewall_popup').removeClass('active');
        $("body").removeClass("popup_no_scroll");

    }

    getRegionDropdown = () => {
        $(".regionSelect_options").addClass("active");
        let form = this.state.firewallForm;
        form.regionName = '';
        this.setState({ regionListFilter: this.state.regions, isregionselected: false }, () => this.scrollTop());
    };
    getSelectedRegion = (event, regionOb) => {
        let id = regionOb.id; let region = regionOb.name; let countryName = regionOb.countryName.toLowerCase();
        if(regionOb.status !== 1) {
            return;
        }
        $(".regionSelect_options").removeClass("active");
        let form = this.state.firewallForm;
        if(!this.state.isUserSubscribed) {
            let item = this.state.regionList.find(elem => elem.region === id);
            form.regionUrl = item.url;

        }
        form.regionName = id;
        form.regionState = region;

        this.setState({ countryName: countryName, errorMessg: '', firewallForm: form, regionErrorMsg: '', nameErrorMsg: '', isregionselected: true });
    };
    filterDropDown = (event) => {
        $(".regionSelect_options").addClass("active");
        let name = event.target.name;
        let val = event.target.value;
        let form = this.state.firewallForm;
        form.regionName = val;
        let lcVal = val.toLowerCase();
        let items = this.state.regions.filter(item => item.id.toLowerCase().includes(lcVal) || item.name.toLowerCase().includes(lcVal));
        this.setState({ regionListFilter: items, firewallForm: form });
    };
    loadRegions = () => {
        RegionService.getAll().then((resp) => {
            if(resp === false) {
                this.setState({ regionListFilter: [] });
            }
            this.setState({ regions: resp });
        });

    };
    onFireKeydown = (e, type) => {
        if(e.keyCode === 13) {
            this.createFirewallSubmit(e);
        }
    };

    onFocusOut = (e) => {
        if(!e.currentTarget.contains(e.relatedTarget)) {
            this.setState({ dropRegion: '', isregionselected: true });
            $(".regionSelect_options").removeClass('active');
            $(".region_select_container").removeClass("active");
        }
    };
    render() {
        // const loading = this.state.loading;
        // if (!sessionStorage.firewallLoaded && loading) {
        //     return null;
        // }
        // sessionStorage.firewallLoaded = true
        if(this.state.isRedirectToCCPage) {
            return <Redirect to={ {
                pathname: "/billing/creditcard",
                state: { message: true }
            } }></Redirect>;
        }
        return (
            <body className={ this.state.isRegionStatus && this.state.regionCount > 0 && this.state.isCluster == "show" ? "main_nav_module firewall_main_module important_msg" : "main_nav_module firewall_main_module" }>
                <main>
                    <div className="full_page_loader" style={ { display: this.state.isAction ? 'block' : 'none' } }>
                        <div className="loader_icon"></div>
                    </div>
                    <div class="common_user_message cluster_msg cluster_uiNew" style={ { display: this.state.isRegionStatus && this.state.regionCount > 0 && this.state.isCluster == "show" ? "" : "none" } }>
                        <div class="message_content">
                            { this.state.regionCount == 1 ?
                                <p><span className="cm_title">Region <b>{ this.state.regionString }</b> is under maintenance.  </span>
                                    You will not be able to create resources e.g. instances, volumes, etc., in this region and the existing resources may also become inaccessible during this period. We are trying to resolve this at the earliest. Thank you for your patience.
                                    <a href="https://status.idrivecompute.com/" target="_blank" className="check-status-btn">Check Status</a>
                                </p>
                                :
                                <p><span className="cm_title">Regions <b>{ this.state.regionString }</b> are under maintenance.  </span>
                                    You will not be able to create resources e.g. instances, volumes, etc., in this region and the existing resources may also become inaccessible during this period. We are trying to resolve this at the earliest. Thank you for your patience.
                                    <a href="https://status.idrivecompute.com/" target="_blank" className="check-status-btn">Check Status</a>
                                </p>
                            }
                            <span class="close_icon" data-tip data-for="closeCluster" onClick={ () => { this.setState({ isRegionStatus: false }); localStorage.setItem("clusterMessage", "hide"); } }></span>
                            <ReactToolTip id="closeCluster" place="left" effect="solid">Close</ReactToolTip>
                        </div>
                    </div>
                    <LeftNav isActive={ 'firewall' }></LeftNav>

                    <div className="main_container">
                        <header className="header_wrap">
                            <HeaderTop showCreate={ true } isUserSubscribed={ this.state.isUserSubscribed }></HeaderTop>
                            <div className="header_wrap_bottom">
                                <div className="bottom_navbar">
                                    <div className="bn_left">
                                        <div className="computer_no">
                                            <span className="text bold_600">Firewalls</span>
                                        </div>
                                    </div>
                                    <div className="bn_right" style={ { display: this.state.firewalls.length > 0 ? "" : "none" } }>
                                        <div className="rhs_info" >
                                            <p>Number of firewalls: { this.state.firewalls.length }</p>
                                        </div>
                                        <div className="divider"></div>
                                        <div className="rhs_cta" >
                                            <div className="btn_wrap_icon btnDefaultPad">
                                                <input
                                                    type="button"
                                                    name=""
                                                    value="Create Firewall"
                                                    className="common_cta_btn blue add_ssh_cta"
                                                    onClick={ () => this.createFirewallClick() } />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </header>
                        <NotificationSlider />
                        <section className="main_section">
                            <div className="main_body_container">
                                <div className="mainBody_colWrap">
                                    <div className="firewall_container">
                                        <div className="firewallMain_table firewall_grpTable">
                                            <div className="tabular_data_wrap">
                                                <div className="table_header">
                                                    <ul>
                                                        <li className="th">
                                                            <div className="col col1">
                                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("name"); } }>Name<span className="sort_icon"></span>
                                                                </div>
                                                            </div>
                                                            <div className="col col2">
                                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("rules"); } }>Rules<span className="sort_icon"></span>
                                                                </div>
                                                            </div>
                                                            <div className="col col3">
                                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("region"); } }>Region<span className="sort_icon"></span>
                                                                </div>
                                                            </div>
                                                            <div className="col col4">
                                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("date"); } }>Created On<span className="sort_icon active"></span>
                                                                </div>
                                                            </div>
                                                            <div className="col col5">Actions</div>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="table_data">
                                                    <ul>{ this.state.firewalls.length === 0 && !this.state.isAction ?
                                                        <div className="outer_empty_wrap fullPageEmpty">
                                                            <div className="inner_empty_wrap">
                                                                <div className="svg_wrap empty_icon firewallCreate_empty"></div>
                                                                <p className="empty_head">Firewalls</p>
                                                                <p className="empty_title">Add a firewall to define network access to your instances.</p>
                                                                <div className="cta_wrap"> <input type="button" value="Create Firewall" onClick={ () => this.createFirewallClick() } className="common_cta_btn blue" /></div>
                                                            </div>
                                                        </div> : this.state.firewalls
                                                            .map((firewall, i) => <li className="tr" key={ i } >
                                                                <div className="col col1" onClick={ () => this.editFirewall([firewall.name, firewall.rules_count, firewall.id, firewall.region_url, firewall.region_name]) }>
                                                                    <div className="name_icon">
                                                                        <span className="svg_wrap">
                                                                            <svg
                                                                                x="0px"
                                                                                y="0px"
                                                                                viewBox="0 0 25 25"
                                                                                enableBackground="new 0 0 25 25"
                                                                                xmlSpace="preserve">
                                                                                <g>
                                                                                    <path
                                                                                        fill="#5AA6D8"
                                                                                        d="M23.7,12.9c-0.1,0.7-0.4,2.7-1.9,2.8c1.2-4.3-2.9-7.5-3.9-7.6c0.5,2.6-0.6,3.2-2.4,5.7   c-3.8,5.7,1.5,9.3,1.5,9.3c0.5,0.4,1.3,0.2,3.4,0.3C27.4,21.4,23.8,12.1,23.7,12.9z"></path>
                                                                                    <path
                                                                                        fill="#5AA6D8"
                                                                                        d="M12.6,21.4h-0.3v-4.7h0.3v-1.9h-5V10c0-0.6-0.4-0.9-0.9-0.9S5.8,9.5,5.8,10v4.7H1.9V10h4.7h7.6   c0-0.6,0-1.3,0-1.9h-1.9V3.4H19c1,0,1.9,0.9,1.9,1.9v1.9v0.9c0,0.6,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9V7.2V4.4c0-1.6-1.2-2.8-2.8-2.8   H2.8C1.2,1.6,0,2.9,0,4.4v16.1c0,1.6,1.2,2.8,2.8,2.8h8.5h1.2v-2H12.6z M1.9,5.3c0-1,0.9-1.9,1.9-1.9h6.6v4.7H1.9V5.3z M10.4,21.4   H3.8c-1,0-1.9-0.9-1.9-1.9v-2.8h8.5V21.4z"></path>
                                                                                </g>
                                                                            </svg>
                                                                        </span>
                                                                    </div>
                                                                    <span data-tip data-for={ firewall.id }>{ firewall.name }</span><ReactToolTip id={ firewall.id } effect="solid">{ firewall.name } </ReactToolTip></div>
                                                                <div className="col col2" onClick={ () => this.editFirewall([firewall.name, firewall.rules_count, firewall.id, firewall.region_url, firewall.region_name]) }>{ firewall.rules_count }</div>
                                                                <div className="col col3" onClick={ () => this.editFirewall([firewall.name, firewall.rules_count, firewall.id, firewall.region_url, firewall.region_name]) }>{ firewall.fullRegion }</div>
                                                                <div className="col col4" onClick={ () => this.editFirewall([firewall.name, firewall.rules_count, firewall.id, firewall.region_url, firewall.region_name]) }>{ getDate(firewall.created_on) }</div>
                                                                <div className="col col5">
                                                                    <span className="menu_icon" onClick={ (e) => { this.getfirewalloptions(e, firewall.id); } }>
                                                                        <span className="svg_wrap">
                                                                            <svg
                                                                                className="horizMenuIcon"
                                                                                x="0px"
                                                                                y="0px"
                                                                                viewBox="0 0 22.1 6.3"
                                                                                enableBackground="new 0 0 22.1 6.3"
                                                                                xmlSpace="preserve"
                                                                                data-tip data-for="actions">
                                                                                <path
                                                                                    fillRule="evenodd"
                                                                                    clipRule="evenodd"
                                                                                    fill="#8692B0"
                                                                                    d="M19,5.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5  S20.4,5.7,19,5.7z M11,5.7c-1.4,0-2.5-1.1-2.5-2.5S9.6,0.7,11,0.7s2.5,1.1,2.5,2.5S12.4,5.7,11,5.7z M3,5.7c-1.4,0-2.5-1.1-2.5-2.5  S1.6,0.7,3,0.7s2.5,1.1,2.5,2.5S4.4,5.7,3,5.7z"></path>
                                                                            </svg><ReactToolTip id="actions" place="top" effect="solid">Actions</ReactToolTip>
                                                                        </span>
                                                                        <ul className={ this.state.enablefirewalloptions && this.state.rowname === firewall.id ? 'dropdown_component firewall_row_options active' : 'dropdown_component firewall_row_options' }>
                                                                            <span className="arrow_pointer"></span>
                                                                            <li className="edit" onClick={ () => this.editFirewall([
                                                                                firewall.name, firewall.rules_count, firewall.id, firewall.region_url, firewall.region_name
                                                                            ]) }>
                                                                                <span className="icon">
                                                                                    <span className="svg_wrap">
                                                                                        <svg
                                                                                            x="0px"
                                                                                            y="0px"
                                                                                            width="19.6px"
                                                                                            height="16.5px"
                                                                                            viewBox="0 0 19.6 16.5"
                                                                                            enableBackground="new 0 0 19.6 16.5"
                                                                                            xmlSpace="preserve">
                                                                                            <path
                                                                                                fillRule="evenodd"
                                                                                                clipRule="evenodd"
                                                                                                fill="#909AAA"
                                                                                                d="M16.2,5.5l-0.7,0.7l-0.7,0.7l-6.2,6.8h5.2c0.6,0,1,0.4,1,1  s-0.4,1-1,1h-10l0,0h-1v-4l7.8-9L11.3,2L12,1.3c0.8-0.8,2-0.8,2.8,0l1.4,1.4C17,3.5,17,4.8,16.2,5.5z M11.7,4.5L5.1,12  c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l6.6-7.6L11.7,4.5z"></path>
                                                                                        </svg>
                                                                                    </span>
                                                                                </span>Edit</li>
                                                                            <li className="delete" onClick={ () => this.deletePoupClick(firewall) }>
                                                                                <span className="icon">
                                                                                    <span className="svg_wrap">
                                                                                        <svg
                                                                                            x="0px"
                                                                                            y="0px"
                                                                                            viewBox="0 0 512 512"
                                                                                            enableBackground="new 0 0 512 512"
                                                                                            xmlSpace="preserve">
                                                                                            <path
                                                                                                fillRule="evenodd"
                                                                                                clipRule="evenodd"
                                                                                                fill="#4C8CCD"
                                                                                                d="M433.5,116.8v303.5c0,27.9-22.7,50.6-50.6,50.6H129.9  c-28,0-50.6-22.7-50.6-50.6V116.8H54.1V66.2h75.9h25.3V40.9h202.4v25.3h25.3h75.9v50.6H433.5z M382.9,116.8H129.9v303.5h252.9V116.8  z M231.1,369.7h-50.6V167.4h50.6V369.7z M332.3,369.7h-50.6V167.4h50.6V369.7z"></path>
                                                                                        </svg>
                                                                                    </span>
                                                                                </span>Delete</li>
                                                                        </ul>
                                                                    </span>
                                                                </div>
                                                            </li>)
                                                    }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <div className="main_popup delete_firewall_popup ">
                            <div className="main_popup_wrapper">
                                <div className="main_popup_bg_shadow"></div>
                                <div className="main_popup__inner">
                                    <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => this.deletePoupClose() }></span>
                                        <div className="popup_header">
                                            <div className="sub_title"> Delete</div>
                                        </div>
                                        <div className="popup_body">
                                            <p>Are you sure you want to delete the Firewall <b>{ this.state.selectedFirewallName }</b>?</p>
                                        </div>
                                        <div className="popup_footer">
                                            <div className="popup_footer__btns">
                                                <button id="deleteBtn" className="btn btn_confirm" onClick={ this.firewallDeleteById }>Delete</button>
                                                <button className="btn btn_cancel" onClick={ () => this.deletePoupClose() }>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="main_popup create_firewall_popup">
                            <div className="main_popup_wrapper">
                                <div className="main_popup_bg_shadow"></div>
                                <div className="main_popup__inner">
                                    <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => this.createFirewallClose() }></span>
                                        <div className="popup_header">
                                            <div className="sub_title"> Create Firewall</div>
                                        </div>
                                        <div className="popup_body">
                                            <span>Create a firewall to control network traffic for the instances</span>

                                            <br /><br />
                                            <label style={ { color: '#010101' } } >Regions</label>
                                            <div className="common_txtBox_row region_select" style={ { color: '#010101', paddingTop: '6px' } }  >
                                                <div className="region_select_container">
                                                    <div className="slectBox" onClick={ this.getRegionDropdown }>
                                                        <div className={ this.state.isregionselected ? "search_inp_box optSelect" : "search_inp_box optUnselect" }>
                                                            <input type="text" name="region" value={ this.state.firewallForm.regionName } placeholder="Select a Region" onChange={ this.filterDropDown } autoComplete="off"></input>
                                                        </div>
                                                        <ul>
                                                            <li className="selected_elem"><span className={ "country_flag " + this.state.countryName.toLowerCase() }></span>{ this.state.firewallForm.regionState } ({ this.state.firewallForm.regionName })</li>
                                                        </ul>
                                                        <span className="dropArrow"> <svg className="header_nav_dropdown" viewBox="0 0 10 5">
                                                            <title>drop-down</title>
                                                            <polygon className="cls-1" points="5 5 0 0 10 0 5 5"></polygon>
                                                        </svg>
                                                        </span>
                                                    </div>
                                                    <div className="regionSelect_options">

                                                        { this.state.regionListFilter.length <= 0 ?
                                                            <ul className="noSearchRes" style={ { display: this.state.regionListFilter.length <= 0 ? "" : "none" } }>
                                                                <li>No matching region found</li>
                                                            </ul>
                                                            :
                                                            <ul>
                                                                <ScrollArea ref={ this.scrollRef }
                                                                    speed={ 0.8 }
                                                                    style={ { maxHeight: "245px" } }
                                                                    vertical={ true }
                                                                    horizontal={ false }
                                                                    minScrollSize={ 10 }
                                                                    smoothScrolling={ false }
                                                                    verticalScrollbarStyle={ { backgroundColor: "#C1C1C1", opacity: "1" } }
                                                                    verticalContainerStyle={ { backgroundColor: "#F1F1F1", opacity: "1" } }
                                                                    stopScrollPropagation={ true }
                                                                >
                                                                    { this.state.regionListFilter.map((region, i) =>
                                                                        <li className={ "option_elem " + region.statusClass } key={ i } onMouseDown={ (e) => this.getSelectedRegion(e, region) } disabled={ region.status !== 1 }><span className={ 'country_flag ' + region.countryName.toLowerCase() } ></span>{ region.name } ({ region.id }) <span className="algin_right__arrow" style={ { display: region.status === 1 ? 'none' : '' } }>{ region.statusName }</span>
                                                                        </li>
                                                                    ) }
                                                                </ScrollArea>
                                                            </ul>
                                                        }
                                                    </div>
                                                    <span className="comm_error_msg" >{ this.state.regionErrorMsg }</span>
                                                </div>
                                            </div>

                                            <div className="common_txtBox_row">
                                                <label>Name</label>
                                                <input type="text" id="secgName" placeholder="Provide a name" name="name" value={ this.state.firewallForm.name } maxLength="20" autoComplete="off"
                                                    onChange={ this.formChangeHandler } className="txtBox create_name_inp" onKeyDown={ (e) => this.onFireKeydown(e) } />
                                                <span className="comm_error_msg">{ this.state.nameErrorMsg }</span>
                                                <span className="comm_error_msg">{ this.state.errorMsg }</span>
                                            </div>
                                        </div>
                                        <div className="popup_footer">
                                            <div className="popup_footer__btns">
                                                <button id="createBtn" className={ this.state.isCreateAction ? "btn blue submitLoader" : "btn blue" } onClick={ this.createFirewallSubmit }>Create</button>
                                                <button className="btn btn_cancel" onClick={ () => this.createFirewallClose() }>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <CommonMessage message={ this.state.message } isUserSubscribed={ this.state.isUserSubscribed } msgType={ this.state.msgType } handler={ () => this.setState({ message: '', msgType: '' }) } />
            </body>
        );
    }
}
function asyncCall() {
    return new Promise((resolve) => setTimeout(() => resolve(), 1600));
}

function getDate(inpDate) {
    let d = new Date(inpDate);
    let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ', ' + d.getFullYear() + ' ' + d.toLocaleString([], {
        hour: '2-digit',
        minute: '2-digit'
    });
    return createdDate;
}
function loadcss() {
    const link = document.createElement("link");
    link.href = "https://www.idrivecompute.com/webapp/css/firewall.css";
    link.rel = "stylesheet";
    link.type = "text/css";
    document.head.appendChild(link);
}
export default withRouter(Firewall);
